import { changeNavOpenkey, changeNavSelectkey,showCaseInfo,hideCaseInfo} from "../constants/index"

let evn={
    changeNavOpenkey:function (key) {
        return {
            type:changeNavOpenkey,
            openkeyArr:key,
        }
    },
    changeNavSelectkey:function (key) {
        return {
            type:changeNavSelectkey,
            selectArr:key,
        }
    },
    showModal: function () {
        return {
            type:"showModal"
        }
    },
    closeModal: function () {
        return {
            type:"closeModal"
        }
    },
    showCaseInfo: function (cid, fromType) {
        return {
            type: showCaseInfo,
            caseId: cid,
            fromType: fromType
        }
    },
    hideCaseInfo: function (cid) {
        return {
            type: hideCaseInfo,
            caseId: cid
        }
    },
    changeTagKey: function (key) {
        return {
            type: "change",
            key: key,
        }
    },
};
export default evn


// WEBPACK FOOTER //
// ./src/actions/index.js